module.exports = __webpack_public_path__ + "static/media/sort-alpha-down.b73776eb.svg";